import { atom } from "recoil";

// Session-only route metadata for the user dashboard header.
export const userPageHeaderState = atom({
  key: "userPageHeaderState",
  default: {
    navLink: "Dashboard",
    header: "Dashboard",
    subtitle: "An overview of your lab and clinic activity.",
    icon: null,
  },
});
